import React, { useEffect, useState } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import queryString from 'query-string';
import { Button } from '@deeptrue-frontend/ui';

import { useFormatMessage } from 'components/IntlProvider';
import { Dashboard } from 'components/Layout';
import api from 'api/api';
import StoreProvider from 'components/StoreProvider/StoreProvider';
import { ProductsReducerType } from 'store/modules/products/products.types';
import Products from 'components/Products/Products';
import EmptyPlaceholder from 'components/EmptyPlaceholder/EmptyPlaceholder';
import RouterProvider from 'components/RouterProvider/RouterProvider';
import AdminMenu from 'components/AdminMenu/AdminMenu';

const { ROUTES } = RouterProvider;
const { connect, selectors, actions } = StoreProvider;

interface WorkbenchesListProps extends RouteComponentProps {
  products: ProductsReducerType['list'];
  setProducts: (payload: ProductsReducerType['list']) => void;
}

const ProductsList = ({
  products,
  setProducts,
  location,
  history,
}: WorkbenchesListProps) => {
  const t = useFormatMessage();
  const [isLoaded, setIsLoaded] = useState(false);

  const parsedSearch = queryString.parse(location.search);

  const refreshProducts = () => {
    setIsLoaded(false);
    api.resources
      .getProducts(
        parsedSearch as {
          limit: string;
          offset: string;
          search: string;
        }
      )
      .then(({ data }) => {
        setProducts(data);
      })
      .finally(() => {
        setIsLoaded(true);
      });
  };

  useEffect(() => {
    refreshProducts();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search]);

  const getPageNumber = () => {
    if (parsedSearch.offset && !Array.isArray(parsedSearch.offset)) {
      return parseInt(parsedSearch.offset, 10) / 20 + 1;
    }

    return 0;
  };

  return (
    <Dashboard title="Products" location={location}>
      <AdminMenu />

      <Button
        color="primary"
        mb="2rem"
        onClick={() => history.push(ROUTES.ADMIN.PRODUCTS.CREATE)}
      >
        {t('dashboard.products.new', 'New Product')}
      </Button>
      <EmptyPlaceholder
        isLoaded={isLoaded}
        hasValues={products.results.length > 0}
        withLoader
      >
        <Products
          list={products.results}
          count={products.count}
          currentPage={getPageNumber()}
          refresh={refreshProducts}
        />
      </EmptyPlaceholder>
    </Dashboard>
  );
};

export default connect(
  (state) => ({
    products: selectors.products.list(state),
  }),
  {
    setProducts: actions.products.setProducts,
  }
)(ProductsList);
